import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails} from 'views/components';
import {Stack, Divider, Badge, ListItemIcon, Button, Box} from 'views/components';
import {DragIndicator} from 'views/icons';
import {Translate} from 'views/module';

import CareviewTypes from './careview_types';
import CareViewItemDelete from './CareViewItemDelete';

const CareViewItem = (props) => {
  const [isExpanded, setIsExpanded] = React.useState(true);
  const [showDragHandle, setShowDragHandle] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  const careviewItem = props.careviewItem;
  const index = props.index;
  const updateQuestion = props.updateQuestion;
  const deleteQuestion = props.deleteQuestion;

  const type = careviewItem.type;

  const CareviewType = CareviewTypes[type];

  if (!CareviewType) {
    return null;
  }

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={(event, isExpanded) => setIsExpanded(isExpanded)}
        sx={{width: 1}}
        disableGutters
      >
        <AccordionSummary
          sx={{
            '&.Mui-focusVisible': {
              backgroundColor: 'inherit',
            },
            '& .MuiAccordionSummary-content': {
              ml: 1,
              textTransform: 'none',
            },
          }}
        >
          <Stack direction='row' spacing={1} alignItems='center' width={1}>
            <ListItemIcon className='drag-handle' sx={{display: 'flex', justifyContent: 'center'}}>
              <Badge
                badgeContent={
                  showDragHandle ? <DragIndicator/> : index
                }
                color='primary'
                data-testid='taskBadge'
                aria-label='task-number'
                onMouseOver={() => setShowDragHandle(true)}
                onMouseLeave={() => setShowDragHandle(false)}
                sx={{
                  '& .MuiBadge-badge': {
                    'fontSize': '16px',
                    'height': '32px',
                    'width': '32px',
                    'borderRadius': '20px',
                    'color': showDragHandle ? 'rgba(0, 0, 0, 0.54)' : undefined,
                    'bgcolor': showDragHandle ? 'transparent' : 'primary',
                    'cursor': 'grab',
                  },
                }}
              />
            </ListItemIcon>
            <CareviewType.Title
              careviewItem={careviewItem}
            />
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{py: 0, px: {xs: 0, md: 2}}}>
          <Box pt={2} ml={{xs: 1, md: 5}}>
            <CareviewType.Content
              careviewItem={careviewItem}
              updateQuestion={updateQuestion}
            />
            <Divider
              sx={{
                pt: 1,
              }}
            />
            <Box
              sx={{
                justifyContent: 'flex-end',
                display: 'grid',
              }}
            >
              <Button
                variant='text'
                onClick={() => setIsDeleting(true)}
                disabled={false}
                color='error'
                sx={{
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
              >
                <Translate
                  expression='client.ClientDetail.CareviewSettings.Types.Actions.Delete'
                />
              </Button>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      {
        isDeleting &&
        <CareViewItemDelete
          deleteQuestion={deleteQuestion}
          close={() => setIsDeleting(false)}
        />
      }
    </Stack>
  );
};

CareViewItem.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  updateQuestion: PropTypes.func.isRequired,
  deleteQuestion: PropTypes.func.isRequired,
};
export default React.memo(CareViewItem);
